__webpack_require__.p = "/ai-learning-universe/";